class pgweb.ModuleSearchBox
	searchbox = null
	lasttime = null
	nowtime = null
	query = ''
	delay = 400
	ongoing = false

	@init: ->
		$('body').on 'listviewbeforefilter', '#module-searchbox', (event, data) ->
			searchbox = $(this)
			getInfo data
		
		$('body').on 'popupafteropen', '#search-modules-popup', (event) ->
			$('#search-modules-popup').find('input').focus()

		$('body').on 'click', '#search-modules-button', (event) ->
			$('#search-modules-popup').popup 'open', {transition: 'pop'}

		setInterval checkSearchBox, 250

	getInfo = (data) ->
		searchbox.html ''
		# Remove ugly shadow on clear button (only theme 'a').
		$('.ui-input-clear').removeClass 'ui-shadow'
		query = $(data.input).val()
		if query.length > 2
			lasttime = nowtime;
			nowtime = getCurrentTime()
		else query = ''

	checkSearchBox = ->
		if not query then return
		
		mynowtime = getCurrentTime()
		if mynowtime - nowtime < delay then return

		if not ongoing
			ajaxFind query
		query = ''

	ajaxFind = (storedQuery) ->
		ongoing = true
		waitStart()
		networkId = $.url().param().networkId
		$.ajax
			url: "/pgweb/ajax/module/searchModules.php"
			dataType: 'json'
			type: 'POST'
			data:
				networkId: networkId
				query: storedQuery
			success: (data) ->
				if data.result == "OK"
					searchbox.html ''
					$.each data.modules, (i, moduleData) ->
						url = '?action=showModule&networkId='+networkId+'&moduleTypeId=0&moduleId='+moduleData.id
						li = $('<li></li>')
							.append(
								$('<a></a>')
									.attr('href', url)
									.append(moduleData.system_name+' ['+moduleData.where+']')
							)
						searchbox.append li
						searchbox.listview 'refresh'
				else if data.result == 'NOT_AUTHENTICATED'
					handleInactivity()
				else
					alert "Searching modules failed: "+data.debug
			error: ajaxFailure
			complete: ->
				waitStop()
				ongoing = false

	getCurrentTime = ->
		mynowdate = new Date()
		mynowdate.getTime()

$ ->
	# Run on all pages where there is a module search button. 
	if $('#search-modules-button').length > 0
		pgweb.ModuleSearchBox.init()
